import AnonymousLayout from '@/layouts/anonymous';
import LoginForm from '../components/login-form';

const pageProps = {
};

const LoginPage = () => <AnonymousLayout Component={LoginForm} componentProps={pageProps} />;

export default LoginPage;
